import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ReceivedResourcesDto } from 'src/app/data/models/dto/count-users.dto';
import { UserVisualizedOccasionInfoDto } from 'src/app/data/models/dto/user-visualized-occasion-info.dto';
import { VisualizedOccasionsDto } from 'src/app/data/models/dto/visualized-occasion.dto';
import { EventsService } from 'src/app/data/services/events.service';
import { NewsService } from 'src/app/data/services/news.service';
import { VisualizedOccasionsService } from 'src/app/data/services/visualized-occasions.service';
import { SearchBarComponent } from '../search-bar/search-bar.component';

@Component({
  selector: 'app-progress-sum-list-object',
  templateUrl: './progress-sum-list-object.component.html',
  styleUrls: ['./progress-sum-list-object.component.scss'],
})
export class ProgressSumListObjectComponent implements OnInit {
  @Input() sumtext: string = '';
  @Input() textlist: string = '';
  @Input() index: number = 0;
  @Input() idOccasion: string | undefined = '';
  @Input() typeOccasion: string = '';
  @Output() loadingComplete = new EventEmitter<boolean>();
  @ViewChild(SearchBarComponent) searchBar = new SearchBarComponent();
  loading: boolean = false;
  placeholder: string = 'Nome do responsável';
  initialList: UserVisualizedOccasionInfoDto[] | undefined = [];
  dynamicList: UserVisualizedOccasionInfoDto[] = [];
  visualized: number = 0;
  percent: number = 0;
  elegible: number = 0;
  objVisualized: VisualizedOccasionsDto | undefined = {};

  constructor(
    private readonly visualizedOccasionsService: VisualizedOccasionsService,
    private readonly newsService: NewsService,
    private readonly eventsService: EventsService
  ) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;
    if (this.idOccasion) {
      await this.buildData(this.idOccasion);
    }
  }

  async buildData(idOccasion: string) {
    await this.usersVisualizedOccasion(idOccasion);
    await this.percentVisualized(idOccasion);
    this.loading = false;
    if (this.objVisualized) {
      this.loadingComplete.emit(this.loading);
    }
  }

  async usersVisualizedOccasion(idOccasion: string): Promise<void> {
    const result = await this.visualizedOccasionsService
      .getVisualizedByIdOccasion(idOccasion)
      .toPromise();
    if (!result) {
      this.objVisualized = undefined;
      this.loading = false;
    } else {
      this.objVisualized = result;
      this.initialList = result.usersVisualized;
      this.dynamicList = this.initialList!;
    }
  }

  async countEligibleUsers(idOccasion: string): Promise<number> {
    let result = { count: 0 };
    if (this.objVisualized) {
      if (this.typeOccasion === 'EVENTS') {
        await this.eventsService
          .countUsersReceived(idOccasion)
          .then((value: ReceivedResourcesDto) => {
            result = value;
          })
          .catch((error: any) => {
            result.count = 0;
            console.log(error);
          });
      }
    }
    return result.count;
  }

  async percentVisualized(idOccasion: string) {
    await this.countEligibleUsers(idOccasion)
      .then((value: number) => {
        this.elegible = value;
      })
      .catch((error) => {
        this.visualized = 0;
        this.percent = 0;
        console.log(error);
      });
    this.visualized = this.objVisualized?.usersVisualized?.length!;
    this.percent = (this.visualized / this.elegible) * 100;
  }

  hasText(text: string, compare: string): boolean {
    return text
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
      .includes(compare.toLowerCase());
  }

  filter(value: string) {
    if (value == undefined || value == '') {
      this.dynamicList = this.initialList!;
    } else {
      this.dynamicList! = this.filterListUser(this.initialList!, value);
    }
  }

  filterListUser(list: UserVisualizedOccasionInfoDto[], value: string) {
    const result = list.filter((el) => {
      return this.hasText(el.fullName, value);
    });
    return result;
  }
}
